import {UserService} from '@nuskin/ns-account';
import localData from './localData.json';
import {getEnv} from '../../config/appEnv';

/**
 * Sets up localStorage with configuration and user data that is provided by the site when
 * not running locally.
 */
export default function localSetup() {
    /*
    * Note: The following will be overriden when the app is deployed. It is only here for development
    * to mock certain env conditions which will be present for a logged-in user in AEM
    */
    const env = getEnv();
    const searchParams = new URLSearchParams(window.location.search);

    console.log('!!! localSetup.searchParams', String(searchParams));

    const locale = searchParams.get('locale') || 'en_US';
    const [language, country] = locale.split('_');

    document.cookie = 'loggedIn=true;path=/';

    // init User
    const userId = searchParams.get('userId') || localData.user.id;
    console.log('!!! localSetup.searchParams.userId:', userId);
    localData.user.id = userId;
    UserService.writeUserToStorage(localData.user);

    // init RunConfig
    localData.runConfig.country = country;
    localData.runConfig.language = language;
    // This is the base of the AEM location
    localData.runConfig.baseUrl = env.contentUrl;
    sessionStorage.setItem('run-config', JSON.stringify(localData.runConfig));
}
